<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.FIRMWARE' | translate }}</h1>
                <div class="content" *ngIf="canManageFirmware">
                    <button (click)="openFirmwareDetailPanel()" class="primary" type="button">
                        {{ 'BUTTONS.CREATE_FIRMWARE' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </div>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'name'"
            [defaultAscending]="sortKey === 'name' && sortAscending"
            [sort]="true"
            [dynamicWidth]="100"
            [text]="'FEATURES.FIRMWARE.COLUMNS.NAME' | translate"
            (sortChanged)="onSortChange('name', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'version'"
            [defaultAscending]="sortKey === 'version' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'FEATURES.FIRMWARE.COLUMNS.VERSION' | translate"
            (sortChanged)="onSortChange('version', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'description'"
            [defaultAscending]="sortKey === 'description' && sortAscending"
            [sort]="true"
            [width]="50"
            [text]="'FEATURES.FIRMWARE.COLUMNS.DESCRIPTION' | translate"
            (sortChanged)="onSortChange('description', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'releaseDate'"
            [defaultAscending]="sortKey === 'releaseDate' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'FEATURES.FIRMWARE.COLUMNS.RELEASE_DATE' | translate"
            (sortChanged)="onSortChange('releaseDate', $event)"
        />
        <app-table-header [align]="align.Center" [width]="8" *ngIf="canManageFirmware" />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of firmwareVersions$ | async" (click)="openFirmwareDetailPanel(item)">
            <td>{{ item.name }}</td>
            <td>{{ item.version }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.releaseDate | date: 'yyyy-MM-dd' }}</td>
            <td class="center" *ngIf="canManageFirmware">
                <button
                    (click)="confirmDeleteFirmware($event, item)"
                    class="icon"
                    [ngClass]="{ loading: loadingFirmwareIds.includes(item.id) }"
                >
                    <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                </button>
            </td>
        </tr>
    </ng-container>
</app-table>
